import { FiArrowUpRight, FiGlobe, FiMail, FiTwitter } from "react-icons/fi";
import { Link } from "react-router-dom";

const Footer = () => {
  const sections = {
    Directory: [
      { label: "Browse All", to: "/websites" },
      { label: "Categories", to: "/categories" },
      { label: "Top 50", to: "/top-50" },
      { label: "Submit Website", to: "/submit" },
    ],
    Popular: [
      { label: "Technology", to: "/category/technology" },
      { label: "Design", to: "/category/design" },
      { label: "Education", to: "/category/education" },
      { label: "Dev Tools", to: "/category/devtools" },
      { label: "Finance", to: "/category/finance" },
    ],
    Company: [
      { label: "About Us", to: "/about" },
      { label: "Blog", to: "/blog" },
      { label: "Contact", to: "/contact" },
    ],
    Legal: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Service", to: "/terms" },
    ],
  };

  const socials = [
    { icon: FiTwitter, href: "#", label: "Twitter" },
    { icon: FiMail, href: "mailto:hello@sitevault.io", label: "Email" },
    { icon: FiGlobe, href: "#", label: "Website" },
  ];

  return (
    <footer className="bg-slate-900 mt-20">
      {/* Wave */}
      <div className="bg-slate-50">
        <svg
          viewBox="0 0 1440 60"
          fill="none"
          preserveAspectRatio="none"
          className="w-full h-10 sm:h-14"
        >
          <path
            d="M0 60L60 50C120 40 240 20 360 13.3C480 6.7 600 13.3 720 20C840 26.7 960 33.3 1080 30C1200 26.7 1320 13.3 1380 6.7L1440 0V60H0Z"
            fill="#0f172a"
          />
        </svg>
      </div>

      <div className="container-main pt-10 pb-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 lg:gap-10 mb-12">
          {/* Brand — logo only */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-5">
              <img
                src="/logo.png"
                alt="SiteVault"
                className="h-9 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed mb-5">
              The best curated website directory — reviewed and rated by our
              community.
            </p>
            <div className="flex items-center gap-2">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-indigo-600 flex items-center justify-center text-slate-400 hover:text-white transition-all duration-200"
                >
                  <s.icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(sections).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-[10px] font-extrabold uppercase tracking-widest text-slate-500 mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="group flex items-center gap-1 text-sm font-semibold text-slate-400 hover:text-white transition-colors"
                    >
                      {link.label}
                      <FiArrowUpRight
                        size={10}
                        className="opacity-0 group-hover:opacity-100 transition-opacity"
                      />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Newsletter */}
        <div className="py-8 border-y border-slate-800 mb-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <h4 className="font-extrabold text-white mb-1">
                Stay in the loop
              </h4>
              <p className="text-sm text-slate-400">
                Get weekly curated website picks delivered to your inbox.
              </p>
            </div>
            <div className="flex w-full sm:w-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 sm:w-64 bg-slate-800 border-2 border-slate-700 rounded-l-xl px-4 py-2.5 text-sm text-white placeholder-slate-500 font-medium focus:outline-none focus:border-indigo-500 transition-colors"
              />
              <button className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-sm px-5 py-2.5 rounded-r-xl transition-colors flex-shrink-0">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <img
              src="/logo.png"
              alt="SiteVault"
              className="h-5 w-auto object-contain brightness-0 invert opacity-30"
            />
            <p className="text-sm font-semibold text-slate-600">
              &copy; {new Date().getFullYear()} SiteVault. All rights reserved.
            </p>
          </div>
          <div className="flex items-center gap-4">
            {[
              { label: "Privacy", to: "/privacy" },
              { label: "Terms", to: "/terms" },
              { label: "Contact", to: "/contact" },
            ].map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className="text-sm font-semibold text-slate-600 hover:text-slate-300 transition-colors"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
